import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Trans, t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { AuthStore, CommonStore } from 'stores';
import { FLASH, PATHS } from 'config';
import qs from 'query-string';
import { useEffectOnlyOnce } from 'helpers';
import SectionBackground from 'assets/images/auth/background_login.jpg';

import {
    Container,
    Grid,
    Column,
    Card,
    Loader,
    Pictorials,
    Section,
    Typography,
} from 'components';

import { StyledPictorial, StyledReactLink } from 'components/StyledCommon';

const Page = ({ location, history }) => {
    const commonStore = useContext(CommonStore);
    const authStore = useContext(AuthStore);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffectOnlyOnce(() => {
        let query = qs.parse(location.search);
        if (!query.t) {
            setError(true);
        } else {
            setLoading(true);
            authStore
                .confirmEmail(query.t)
                .then(() => {
                    commonStore.flashAlert(FLASH.email_confirmed, {
                        icon: 'checkmark',
                        children: i18n._(
                            t`Your email address has been successfully confirmed.`,
                        ),
                    });
                    history.replace(PATHS.dashboard);
                })
                .catch(() => {
                    setLoading(false);
                    setError(true);
                });
        }
    });

    return (
        <React.Fragment>
            <Section topMargin minHeight="100vh" image={SectionBackground}>
                <Container>
                    <Grid alignCenter>
                        <Column cols={6} tablet={8} desktop={5}>
                            <Card noShadow mobileCard>
                                {error ? (
                                    <div>
                                        <StyledPictorial
                                            color="brand"
                                            icon={Pictorials.Error}
                                        />

                                        <Typography variant="h5">
                                            <Trans>
                                                Sorry, the confirmation link is
                                                not valid.
                                            </Trans>
                                        </Typography>

                                        <Typography
                                            variant="bodys"
                                            spaceTop="base"
                                        >
                                            <Trans>
                                                It seems that the confirmation
                                                link you tried to use is not
                                                valid anymore. You can go back
                                                to{' '}
                                                <StyledReactLink
                                                    $fontWeight={400}
                                                    $size="bodys"
                                                    to="/"
                                                >
                                                    your dashboard
                                                </StyledReactLink>{' '}
                                                and try again.
                                            </Trans>
                                        </Typography>
                                    </div>
                                ) : null}

                                {loading ? (
                                    <React.Fragment>
                                        <Typography
                                            variant="bodym"
                                            align="center"
                                        >
                                            <Trans>
                                                Verifying your email address...
                                            </Trans>
                                        </Typography>

                                        <Loader absolute position="bottom" />
                                    </React.Fragment>
                                ) : null}
                            </Card>
                        </Column>
                    </Grid>
                </Container>
            </Section>
        </React.Fragment>
    );
};

export default withRouter(observer(Page));
